export const TABLE_CELL_CLASSES =
  "bg-inherit shadow-[inset_0px_-1px_0px] shadow-gray-200 min-h-[72px] px-4 py-2 break-words relative"
